export enum LoginCardEnum {
  LOGIN = "login",
  SET = "set",
  RESET = "reset",
  FORGOT = "forgot",
  LOGOUT = "logout"
}
